import React from 'react'

import './email.css'

const Email = () => {
  return (
    <>
        <>ular.shalomspringsofplano@gmail.com</>
    </>
  )
}

export default Email